import {
    ActionFunction,
    redirect
} from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";


export const userAction: ActionFunction = async ({ request, params }) => {
    const formData = await request.formData();
    const updates = Object.fromEntries(formData);
    if (params.id === "new")
        await axiosApi.post("/api/users", updates);
    else await axiosApi.put("/api/users", { ...updates, id: params.id });
    return redirect(`/users`);
}